import { useState, useEffect } from 'react';

function getValuesInStorage(key, initialValue) {
  const result = JSON.parse(localStorage.getItem(key));
  if (result) return result;
  if (initialValue instanceof Function) return initialValue();
  return initialValue;
}

export default function useLocalStorage(key, defaultValue) {
  const [value, setValue] = useState(() => {
    return getValuesInStorage(key, defaultValue);
  });

  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(value));
  }, [value]);

  return [value, setValue];
}
